export default "__VITE_ASSET__Wt3cZ4ZY__"